<template>
<div>
	<div class="row">

		<div class="col-12">

			<b-jumbotron class="mb-3 p-4">

				<h2 class="display-4">{{ $t('lists.catalog') }}</h2>

				<div class="row">

					<div class="col-lg-8 col-xl-6 col-md-12">

						<list-download-button :label=" $t('lists.masterCatalog')"
							:placeholder="$t('lists.allCatagories')"
							@download="downloadMasterCatalog"
							:loading="loading.master"
						/>

						<list-download-button :label="$t('lists.userCatalog')"
							:placeholder="$t('lists.allCatagories')"
							@download="downloadUserCatalog"
							:loading="loading.users"
						/>

						<list-download-button :label="$t('lists.registerCatalog')"
							:placeholder="$t('lists.allCatagories')"
							@download="downloadRegisterCatalog"
							:loading="loading.register"
						/>

					</div>

				</div>

			</b-jumbotron>

			<b-jumbotron class="mb-3 p-4">
				<h2 class="display-4">{{ $t('lists.buyersSince') }}</h2>
				<div class="row">
					<div class="col-lg-8 col-xl-6 col-md-12">

						<b-form-group label="Vanaf datum:">
							<div class="row align-items-bottom">
								<div class="col">
									<b-input-group>
										<b-input-group-prepend is-text><i class="fas fa-calendar-alt fa-fw"></i></b-input-group-prepend>
										<datepicker
											v-model="buyersDate"
											:format="convertDate"
											input-class="text-right form-control date-field"
											>
										</datepicker>
									</b-input-group>
								</div>

								<div class="col-4">
									<loader-button variant="primary"
										@click="downloadBuyersSince"
										block
										:loading="loading.buyersSince"
									>
										{{ $t('lists.download') }}
									</loader-button>
								</div>
							</div>
						</b-form-group>
					</div>
				</div>
			</b-jumbotron>

			<b-jumbotron class="mb-3 p-4">

				<h2 class="display-4">{{ $t('lists.exports') }}</h2>

				<div class="row">

					<div class="col-lg-8 col-xl-6 col-md-12">

						<div class="row">
							<div class="col-8">
								<h4>Exporteer kavels naar Excel bestand</h4>
							</div>
							<div class="col-4">
								<loader-button variant="primary"
									@click="exportItems"
									block
									:loading="loading.exports"
								>
									{{ $t('lists.download') }}
								</loader-button>
							</div>
						</div>

					</div>

				</div>

			</b-jumbotron>

			<b-jumbotron class="mb-3 p-4">

				<h2 class="display-4">{{ $t('lists.persons') }}</h2>

				<div class="row mb-3"
				     v-for="(list, i) in downloadPersons">

					<div class="col-lg-8 col-xl-6 col-md-12">

						<label>{{ list.label }}</label>
						<div class="row">
							<div class="col-8">
								<multiselect v-model="list.selectedOption"
								             :options="list.downloadOptions"
								             :multiple="false"
								             label="label"
								             :preselect-first="true"></multiselect>

							</div>
							<div class="col-4">
								<loader-button block
									variant="primary"
									@click="list.downloadFunction(list.selectedOption)"
									:loading="i ? loading.buyers : loading.sellers"
								>
									{{ $t('lists.download') }}
								</loader-button>
							</div>
						</div>

					</div>

				</div>

			</b-jumbotron>

		</div>

	</div>

</div>
</template>

<script>
import CatalogService from '@/services/catalog-service';
import ListDownloadButton from './ListsDownloadButton.vue';
import AuctionService from '@/services/auction-service';
import PersonService from '@/services/person-service';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';

export default {
	data() {
		return {
			buyersDate: new Date(),
			downloadPersons: [{
					label: this.$t('common.sellers'),
					selectedOption: null,
					downloadFunction: this.downloadSellerList,
					downloadOptions: [
						{ label: this.$t('lists.all'), value: 'all' },
						{ label: this.$t('lists.paidSellers'), value: 'paid' },
						{ label: this.$t('lists.unpaidSellers'), value: 'unpaid' }
					]
				},
				{
					label: this.$t('common.buyers'),
					selectedOption: null,
					downloadFunction: this.downloadBuyerList,
					downloadOptions: [
						{ label: this.$t('lists.unpaidBuyers'), value: 'unpaid' },
						{ label: this.$t('lists.paidBuyers'), value: 'paid' },
						{ label: this.$t('lists.all'), value: 'all' }
					],
				}
			],
			loading: {
				master:   	 false,
				register: 	 false,
				users: 	  	 false,
				exports:  	 false,
				sellers:  	 false,
				buyers:   	 false,
				buyersSince: false,
			},
		}
	},
	components: {
		ListDownloadButton,
		Multiselect,
		Datepicker
	},
	methods: {
		convertDate(date) {
			let dateOptions = { year:'numeric', month:'short', day:'numeric' };
			let d = new Date(date);

			return `${d.toLocaleDateString('nl', dateOptions)}`
		},

		async downloadBuyersSince() {
			this.loading.buyersSince = true;

			try {
				const response = await AuctionService.getBuyersSinceExport(
					this.$route.params.auctionId, { date: (new Date(this.buyersDate)).toLocaleString('nl') }
				)

				this.downloadCatalog(response, 'Lijst kopers');

				this.loading.buyersSince = false;
			}
			catch (error) {
				this.loading.buyersSince = false;
			}
		},

		async downloadMasterCatalog(category_id) {
			this.loading.master = true;

			try {
				const response = await CatalogService.getMasterCatalog(this.$route.params.auctionId, { category_id })

				this.downloadCatalog(response, 'Master');

				this.loading.master = false;
			}
			catch (error) {
				this.loading.master = false;
			}
		},

		async downloadUserCatalog(category_id) {
			this.loading.users = true;

			try {
				const response = await CatalogService.getUserCatalog(this.$route.params.auctionId, { category_id })

				this.downloadCatalog(response, 'Gebruikers');

				this.loading.users = false;
			}
			catch (error) {
				this.loading.users = false;
			}
		},

		async downloadRegisterCatalog(category_id) {
			this.loading.register = true;

			try {
				const response = await CatalogService.getRegisterCatalog(this.$route.params.auctionId, { category_id })

				this.downloadCatalog(response, 'Inboeklijst');

				this.loading.register = false;
			}
			catch (error) {
				this.loading.register = false;
			}
		},

		async exportItems() {
			this.loading.exports = true;

			try {
				const response = await AuctionService.getAuctionItemsExport(this.$route.params.auctionId);

				this.downloadCatalog(response, 'Kavellijst');

				this.loading.exports = false;
			}
			catch (error) {
				this.loading.exports = false;
			}
		},

		async downloadSellerList(type) {
			this.loading.sellers = true;

			try {
				const response = await AuctionService.getSellerListUrl(this.$route.params.auctionId, { type: type.value });

				this.downloadCatalog(response, 'Inbrengerslijst');

				this.loading.sellers = false;
			}
			catch (error) {
				this.loading.sellers = false;
			}
		},

		async downloadBuyerList(type) {
			this.loading.buyers = true;

			try {
				const response = await AuctionService.getBuyerListUrl(this.$route.params.auctionId, { type: type.value });

				this.downloadCatalog(response, 'Cliëntenlijst');

				this.loading.buyers = false;
			}
			catch (error) {
				this.loading.buyers = false;
			}
		},

		downloadCatalog(response, name) {
			const data = window.URL.createObjectURL(response);
			const dateString = `${(new Date()).toLocaleDateString('nl', { year:'numeric', month:'numeric', day:'numeric' })}`
			let aTag = document.createElement('a');
			
			aTag.href = data;
			aTag.download = `${name} ${dateString}.pdf`;
			aTag.style = "position: absolute; opacity: 0;";
			aTag.target = '_blank';
			
			document.body.appendChild(aTag);
			aTag.click();

			setTimeout(function () {
				document.body.removeChild(aTag);
				window.URL.revokeObjectURL(data);
			}, 100);
		},
	},
	mounted() {
		this.downloadPersons[0].selectedOption = this.downloadPersons[0].downloadOptions[0];
		this.downloadPersons[1].selectedOption = this.downloadPersons[1].downloadOptions[0];
	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Lists.vue?2b1aff20